module.exports = __webpack_public_path__ + "img/7.8a0a28e4.png";